import { HBox } from "@ui/box/Box"
import Button from "@ui/button/Button"
import { Typo } from "@ui/text/Typo"
import { DS } from "../ds/Kit"

/** "Showing 21–40 of 58" with Previous / Next; renders nothing for an empty list. */
export const ListPager = ({ page, pageSize, total, onPage, label = "items" }: {
	page: number
	pageSize: number
	total: number
	onPage: (page: number) => void
	label?: string
}) => {
	if (total <= 0) return null
	const pageCount = Math.max(1, Math.ceil(total / pageSize))
	const start = page * pageSize + 1
	const end = Math.min(total, (page + 1) * pageSize)
	return (
		<HBox
			role="navigation"
			aria-label={`${label} pages`}
			gap="10px"
			sx={{ justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", padding: "12px 16px", flexShrink: 0 }}
		>
			<Typo sx={{ color: DS.muted, fontSize: "13px" }}>
				{`Showing ${start}–${end} of ${total}`}
			</Typo>
			{pageCount > 1 && (
				<HBox gap="8px" sx={{ alignItems: "center" }}>
					<Button variant="secondarySmall" disabled={page === 0} onClick={() => onPage(page - 1)} sx={{ padding: "6px 12px" }}>
						Previous
					</Button>
					<Typo sx={{ color: DS.ink, fontSize: "13px", fontWeight: 600 }}>
						{`Page ${page + 1} of ${pageCount}`}
					</Typo>
					<Button variant="secondarySmall" disabled={page >= pageCount - 1} onClick={() => onPage(page + 1)} sx={{ padding: "6px 12px" }}>
						Next
					</Button>
				</HBox>
			)}
		</HBox>
	)
}
